import { Decorable } from '../..//types/decorable';
import { CancellablePromise } from '../../types/cancellable-promise';

import { SLMap } from '../sl-map';
import { LayerRenderResult } from '../../types/layerrenderresult';
import { SLLayer, LayerTypeEnum, LayerGeomtypes } from '../sl-layer';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { ColorClass } from 'src/app/types/color-class';
import { ResultsService, ResultMoment } from 'src/app/services/results.service';
import { BufferSrc } from '../buffersrc';
import { BufferInfo } from '../api-services/layer-api.service';
import { IClearable } from 'src/app/types/iclearable';
import { ISelectionInfo, ISelectionData } from '../synchronizer';
import { MapDataAction } from '../map-actions/map_data-action';
import { LabelStyle, LabelStyleInfo } from 'src/app/types/LabelStyle';
import { thousandSeparatorFormatted } from 'angular-slickgrid';
import { destination, Feature, Point, point } from '@turf/turf';
import { Grid9Position } from 'src/app/types/grid9-position';


export class InputBufferLayer extends SLLayer implements IClearable {
	public sourceLayer: SLLayer;
	private features: Array<any>;
	private subs: Array<SLLayer> = [];
	private vis = false;
	private labelVis = false;
	private bufferSrc: BufferSrc = null;
	private buffer = 0;
	private selections: ISelectionInfo;
	private centerLat: string;
	private centerLon: string;
	private bufferBbox: string;
	public inheritLabels = false;
	// tslint:disable-next-line: variable-name

	public myOpacity = 1;

	public useStyle2 = false;
	private moment: ResultMoment;
	public labelInfo = {
		labelField: '_sl_override_',
		labelStyleJSON: { font: 'RobotoBlack', size: 12, color: '#058405', align: 'center', outlinecolor: '#00FF00', outlinewidth: 2, shadowcolor: '#ededed', shadowsizex: 0, shadowsizey: 5, offsetx: 0, offsety: 0, position: 'lc', angle: 'auto' },
		bufferX: 0,
		bufferY: 0,
		inheritLabelStyle: false,
		inheritOnly: false,
		labelOverride: 'Input Buffer',
		override: false,
		labelsOn: false
	};
	public abilities: Decorable = {
		layer_vis: true,
		include_in_search: false,
		show_labels: false,
		include_in_legend: true,
		tooltip: false
	};
	get layerOn(): boolean {
		return this.vis;
	}

	set layerOn(isVis: boolean) {
		this.vis = isVis;
		if (isVis && this.touched) {
			this.Render(this.SLMap);
			this.touched = false;
		} else {
			if (this.overlayLayer === undefined) {
				this.Render(this.SLMap);
			} else {
				try {
					this.overlayLayer.UpdateVisibility();
					// map.ui.getLayer(this.overlayLayer.id);
					// map.ui.setLayoutProperty(this.overlayLayer.ui.id, 'visibility', (isOn && this.parentVis) ? 'visible' : 'none');
				} catch (e) {
					// this.Render(map);
					// do nothing;
				}
			}
		}
		this.visChange.emit({ layer: this });
	}
	SetLayerOn(isVis: boolean, map: SLMap = null) {
		map = map;
		this.layerOn = isVis;
		this.subs = this.subs;
	}
	GetColor() {
		return '';
	}
	get labelsOn(): boolean {
		if (!this.parentSLLayer.labelsOn) {
			return false;
		}

		return this.labelVis;

	}
	set labelsOn(isVis: boolean) {
		this.labelVis = isVis;
	}

	get srcLabelsOn(): boolean {
		return this.labelsOn;

	}

	get opacity(): number {
		if (!!this.myOpacity) {
			return this.myOpacity;
		} else {
			return 0;
		}
	}
	set opacity(level: number) {
		this.myOpacity = level;
		this.overlayLayer.UpdateOpacity();
		this.change$.emit(this);

	}


	get queryAble(): boolean {
		if (this.searchable === false) {
			return false;
		}
		return [
			LayerTypeEnum.Vector.valueOf(),
			LayerTypeEnum.Relational.valueOf()
		].indexOf(+this.type) > -1;
		// return (this.access >= LayerAccessLevel.Read);
	}

	get parentLayer(): string {
		return 'results';
	}

	get searchable(): boolean {
		if ([
			LayerTypeEnum.Vector.valueOf(),
			LayerTypeEnum.Relational.valueOf()
		].indexOf(+this.type) === -1) {
			return false;
		}
		return this.data.search_on === 1;
	}

	set searchable(isSearchable: boolean) {
		this.data.search_on = isSearchable === true ? 1 : 0;
	}

	constructor(map: ISLMap, resultsSvc: ResultsService) {
		super(null, map, null, null, resultsSvc);
		this.myOpacity = 1;
		this._classification = [
			{
				crid: -1,
				criteria1: 'gid',
				criteria2: '>',
				criteria3: 0,
				description: 'Input Buffer',
				priority: 1,
				useFill: false,
				fill: 'trans',
				useStroke: true,
				stroke: '#00FF00',
				field: '',
				operator: '',
				value: '',
				symbol: 'outline_dashes',
				size: 4,
				useLabelStyle: false,
				labelStyle: ''
			},
			{
				crid: -2,
				criteria1: 'gid',
				criteria2: '>',
				criteria3: 0,
				description: 'Input Buffer',
				priority: 2,
				useFill: true,
				fill: '#00FF00',
				useStroke: false,
				stroke: 'trans',
				field: '',
				operator: '',
				value: '',
				symbol: 'complex_screen',
				size: 3,
				useLabelStyle: false,
				labelStyle: ''
			},
		];
		/*
		const me = this;
		 resultsSvc.resultChanges.subscribe((message: ResultChange) => {
			me.ShowOrHide();
			switch (message.change) {
				case 'results/active_layer/set':
				case 'results/set':
				case 'results/selected':
				case 'results/features/change':
					break;
				default:
					return;
			}
			if (!me.enabled) {
				me.Clear();
			} else {
				me.Render(null);
			}

		});
		*/


	}
	SetSelections(data: ISelectionData) {
		if (!this.resultsSvc.CompareSelections(this.selections, data.selections)) {
			this.touched = true;
		}
		this.selections = data.selections;
		this.moment = data.moment;
		this.ShowOrHide();
		if (!this.enabled) {
			this.Clear();
		} else {
			this.Render();
		}
		MapDataAction.UpdateLayerPropertyView(this);
	}
	ShowOrHide() {
		if (!this.selections) {
			this.enabled = false;
			this.layerOn = false;
			this.layerOn = this.enabled;
			return;
		}
		this.centerLat = null;
		this.centerLon = null;
		if (!!this.selections.layer) {
			this.buffer = 0;
			if (!!this.moment) {
				if (!!this.moment.params.distance) {
					// const bufferSrc = this.resultsSvc.currentMoment.bufferSrc;
					this.bufferSrc = this.moment.bufferSrc;
					if (!!this.bufferSrc) {
						this.buffer = this.bufferSrc.value;
					} else {
						this.buffer = this.moment.params.distance;
					}
					this.centerLat = null;
					const params: any = this.moment.params;
					if (!!params.centerLat) {
						this.centerLat = params.centerLat;
					}
					this.centerLon = null;
					if (!!params.centerLon) {
						this.centerLon = params.centerLon;
					}
					this.bufferBbox = null;
					if (!!this.buffer && !(!!this.centerLat)) {
						if (this.buffer !== 0) {
							this.bufferBbox = params.bbox;
						}
					}
					const classes = JSON.parse(JSON.stringify(this._classification));
					if (this.useStyle2 === false) {
						classes.pop();
					}

					if (!!params.memoryLayer) {
						this.sourceLayer = this.map.GetLayerById('' + params.memoryLayer, false);
						this.data = this.sourceLayer.CloneData();
						this.styles = { criteria: JSON.stringify(classes) };
					} else {
						this.sourceLayer = this.selections.layer;
						this.data = this.sourceLayer.CloneData();
						this.styles = { criteria: JSON.stringify(classes) };
						this.enabled = true;
						if (this.layerOn !== this.enabled) {
							this.layerOn = this.enabled;
						}
						if (!(!!this.moment.params.gids)) {
							this.features = [];
							return;
						}
					}

					if (!!this.moment.params.gids) {
						const gids = this.moment.params.gids.split(',');
						this.features = gids;
						this.enabled = true;
						if (!this.layerOn === this.enabled) {
							this.layerOn = this.enabled;
						}
						return;
					}
				}

			}

		}
		this.enabled = false;
		this.layerOn = this.enabled;

	}
	ShowResults(layer: SLLayer, features: Array<any>, styles: any) {
		layer = features = styles = null;
		/*
		this.sourceLayer = layer;
		this.data = layer.CloneData();
		this.enabled = features.length > 0;
		this.features = features;
		this.styles = styles;
		this.layerOn = this.enabled;
		this.labelVis = this.sourceLayer.labelsOn;
		this.labelAttribute = this.sourceLayer.labelAttribute;
		if (this.labelAttribute === 'default') {
			if (!!this.layerAttributes) {
				if (!!this.layerAttributes.length) {
					if (this.layerAttributes.length > 0) {
						this.labelAttribute = this.layerAttributes[0].name;
					}
				}
			}
		}
		if (!this.enabled) {
			this.Clear();
		} else {
			this.Render(null);
		}
		*/
	}

	Clear() {
    this.features = [];
		this.overlayLayer.Clear();
		this.enabled = false;
    this.selections = null;
    this.ShowOrHide();

  }

	get overlayId(): string {
		return this.overlayLayer.id;
	}

	get defaultCriteria(): Array<any> | null {
		return this._classification;
	}

	get description(): string {
		return 'Features used as search input for spatial matching';
	}

	set description(desc: string) {
		desc = null;
		return;
	}

	get id(): string {
		return 'inputBuffer';
	}


	get renderId() {
		return this.sourceLayer.identifier;
	}

	get plid(): string {
		return 'inputBuffer';
	}
	get name(): string {
		return 'Input Buffer';
	}
	set name(name: string) {
		name = name;
		return;
	}
	get geom(): string {
		return LayerGeomtypes[LayerGeomtypes.Polygon];
	}
	get searchtip(): string {
		return (this.data.searchtip === null) ? '' : this.data.searchtip;
	}

	set searchTip(tip: string) {
		this.data.searchTip = (tip === '') ? null : tip;
	}

	get type(): number {
		return LayerTypeEnum.Virtual_ResultBuffer;
	}

	set type(layerType: number) {
		layerType = layerType;
	}

	get typeString(): string {
		return LayerTypeEnum[LayerTypeEnum.Virtual_ResultBuffer];
	}

	get identifier() {
		if (this.isPLayer === true) {
			return this.plid;
		}
		return this.id;
	}

	get subLayers(): Array<any> {
		return [];

	}
	get subSLLayers(): Array<SLLayer> {
		return [];
	}
	get hasSubLayers(): boolean {
		return false;
	}

	Render(map: ISLMap = null, force: boolean = false) {
		if (force === true) {
			this.touched = true;
		}



		this.ShowOrHide();
		if (!this.layerOn && !this.touched && !this.parentVis) {
			return;
		}
		if (this.sourceLayer === undefined) {
			return;
		}
		if (map === null) {
			if (this.SLMap === undefined) {
				return;
			}
			map = this.SLMap;
		}

		if (this.isPLayer) {
			if (this.layerOn === false || this.enabled === false) {
				this.Clear();
				this.touched = true;
				this.rendered.emit({ id: this.identifier, isPLayer: this.isPLayer, status: 'ok' });
				this.enabled = this.layerOn = false;
				return;
			}
		}
		this.rendering.emit({ id: this.identifier, isPLayer: this.isPLayer });
		const me = this;
		const handler = (result: LayerRenderResult) => {
			if (result === undefined) {
				me.Clear();
				this.rendered.emit({
					id: this.identifier,
					isPLayer: this.isPLayer,
					status: 'problem',
					error: 'There was a problem retrieving layer :' + this.name
				});
				return;
			}
			this.enabled = true;
			this.overlayLayer.HandleRenderResult(result);

		};
		const gids: string | null = (!this.features) ? null : this.features.join(',');

		const bufferInfo: BufferInfo = {
			buffer: this.buffer, /*this.bufferSrc.value,*/
			gids: (gids)
		};

		if (this.centerLat !== null) {
			bufferInfo.centerLat = this.centerLat;
		}
		if (this.centerLon !== null) {
			bufferInfo.centerLon = this.centerLon;
		}
		if (this.bufferBbox !== null) {
			bufferInfo.bufferBbox = this.bufferBbox;
		}
		let labelsOn = this.labelsOn;
		let labelStyle = this.labelStyle;
		let labelValue = null;
		if (this.labelInfo.override === true) {
			labelsOn = this.labelInfo.labelsOn;
			labelValue = this.labelInfo.labelOverride;
			labelStyle = JSON.parse(JSON.stringify(this.labelInfo.labelStyleJSON));
			this.labelAttribute = this.labelInfo.labelField;
		}

		/*if (this.labelInfo.override === true) {
			labelsOn = this.labelInfo.labelsOn;
			labelStyle = (JSON.parse(JSON.stringify(this.labelInfo.labelStyleJSON)) as LabelStyle);
			labelValue = this.labelInfo.labelOverride;
			let bearing = 0;
			let angle = 0;
			if (['cc', 'auto'].indexOf(this.labelInfo.labelStyleJSON.position) < 0) {
				switch (this.labelInfo.labelStyleJSON.position as Grid9Position) {
					case 'ul':
						bearing = 315;
						angle = 45;
						break;
					case 'uc':
						bearing = 0;
						break;
					case 'ur':
						bearing = 45;
						angle = -45;
						break;
					case 'cl':
						bearing = 270;
						angle = 90;
						break;
					case 'cc':
						// n/a
						break;
					case 'cr':
						bearing = 90;
						angle = -90;
						break;
					case 'll':
						bearing = 225;
						angle = -45;
						break;
					case 'lc':
						bearing = 180;
						angle = 0;
						break;
					case 'lr':
						bearing = 135;
						angle = 45;
						break;
				}
				const pt = point([Number(this.centerLon), Number(this.centerLat)]);
				const dest: Feature<Point> = destination(
					pt, this.buffer / 1000, bearing, { units: 'kilometers' });
				const context = this.SLMap.component.spatialContext;
				const startPt = context.SpatialCoord({ lng: this.centerLon, lat: this.centerLat }, 'lng', 'lat');
				const endPt = context.SpatialCoord({ lng: dest.geometry.coordinates[0], 'lat': dest.geometry.coordinates[1] }, 'lng', 'lat');
				const pixoStartPt = context.PixoSpatialCoord(startPt).pixo;
				const pixoEndPt = context.PixoSpatialCoord(endPt).pixo;
				const xDelta = Math.abs(pixoEndPt.x - pixoStartPt.x) + (labelStyle as LabelStyleInfo).offsetx;
				const yDelta = Math.abs(pixoEndPt.y - pixoStartPt.y) + (labelStyle as LabelStyleInfo).offsety;
				(labelStyle as LabelStyleInfo).offsetx = xDelta;
				(labelStyle as LabelStyleInfo).offsety = yDelta;
				(labelStyle as any).angle = 'auto';
			}

		}
		*/

		if (this.isPLayer === true) {
			this.SLMap.component.layerAPI.RenderProjectLayerById(
				this,
				map,
				this.features,
				this.styles,
				labelsOn,
				bufferInfo, JSON.stringify(labelStyle), labelValue).then(handler);
			return;
		}
		this.styles.unormal = '1';

		const promise: CancellablePromise | void = this.SLMap.component.layerAPI.RenderLayerById(
			this,
			map,
			this.features,
			this.styles,
			this.labelsOn
		);
		if (promise) {
			promise.then(handler);
		}
	}

	GetFeatures(): Array<any> {
		return this.features;
	}
	HasFeatures(): boolean {
		if (!this.selections) {
			return false;
		}
		if (!this.selections.features) {
			return false;
		}
		return this.selections.features.length > 0;
	}
	ZoomToFeatures() {
		this.SLMap.component.HandleToolAction({
			action: 'info/zoom-to-features',
			layer: this.sourceLayer.id,
			features: this.features.join(',')
		});
	}
	get icon() {
		return 'font-icon';
	}

	get fontIcon() {
		return 'fas fa-dot-circle';
	}
	get preferredView(): string {
		return 'result-buffer';
	}
	get classification() {
		const classes = JSON.parse(JSON.stringify(this._classification));
		if (this.useStyle2 === false) {
			classes.pop();
		}
		return classes;
	}
	public get fullClassification() {
		return this._classification;
	}
	SetLabelInfo(info: any) {
		this.labelInfo = info;
		this.labelsOn = this.labelInfo.labelsOn;
		this.labelOverride = this.labelInfo.labelOverride;
	}
	GetLabelInfo(): any {
		return this.labelInfo;
	}
	IsVirtual() {
		return true;
	}

}

